export class Company {
  public name: string;
  public token: string;

  constructor() {
    this.name = '';
    this.token = '';
  }
}
